import { useTranslation } from 'react-i18next'

interface DockProps {
  /** Header label, e.g. "Stage 01 — Strategy". */
  stage: string
  /** Completion percent 0–100. */
  pct: number
  /** "{filled} of {total}" counter on the right of the bar. */
  filled?: number
  total?: number
  onLoadSample?: () => void
  onSaveDraft?: () => void
  onLoadDraft?: () => void
  onReset?: () => void
  onGenerate?: () => void
}

/**
 * The sticky workspace dock. Mirrors `lorenza.html` exactly: stage chip,
 * COMPLETION %, progress bar, "{n} of {m}", and the five action buttons.
 */
export function Dock({
  stage,
  pct,
  filled = 0,
  total = 0,
  onLoadSample,
  onSaveDraft,
  onLoadDraft,
  onReset,
  onGenerate,
}: DockProps) {
  const { t } = useTranslation()
  const clamped = Math.max(0, Math.min(100, pct))
  return (
    <div className="dock">
      <div className="dock-stage">{stage}</div>
      <div className="dock-stat">
        {t('dock.completion', 'Completion')} <strong>{clamped}%</strong>
      </div>
      <div className="dock-progress" aria-hidden="true">
        <div className="dock-progress-fill" style={{ width: `${clamped}%` }} />
      </div>
      <div className="dock-stat">
        {filled} {t('dock.of', 'of')} {total}
      </div>
      <div className="dock-actions">
        <button
          type="button"
          className="dock-btn ghost"
          onClick={onLoadSample}
          disabled={!onLoadSample}
        >
          {t('dock.loadSample', 'Load Sample')}
        </button>
        <button
          type="button"
          className="dock-btn ghost"
          onClick={onSaveDraft}
          disabled={!onSaveDraft}
        >
          {t('dock.saveDraft', 'Save Draft')}
        </button>
        <button
          type="button"
          className="dock-btn ghost"
          onClick={onLoadDraft}
          disabled={!onLoadDraft}
        >
          {t('dock.loadDraft', 'Load Draft')}
        </button>
        <button
          type="button"
          className="dock-btn ghost"
          onClick={onReset}
          disabled={!onReset}
        >
          {t('dock.reset', 'Reset')}
        </button>
        <button
          type="button"
          className="dock-btn"
          onClick={onGenerate}
          disabled={!onGenerate}
        >
          {t('dock.generate', 'Generate')}
        </button>
      </div>
    </div>
  )
}
